// extracted by mini-css-extract-plugin
export default {"headerBody":"X5IRl SNkEW xn62R","headerTextInput":"ZqOfw FhFee","headerSchema":"AkKxs o3P7r"};